import { Directive, HostBinding, Input } from '@angular/core'
import { ButtonFlatColors, ButtonFlatSizes } from '../../../models/button.interfaces'

@Directive({
    selector: '[appButtonFlat]'
})
export class ButtonFlatDirective {
    @Input() color: ButtonFlatColors = 'primary'
    @Input() size: ButtonFlatSizes = 'small'
    @Input() hoverEffect: boolean = true

    @HostBinding('class.hoverEffect') get buttonHoverEffect(): boolean {
        return this.hoverEffect
    }

    @HostBinding('class') get buttonClass(): string {
        return `app-button-flat app-button-flat-${this.color} app-button-flat-${this.size}`
    }
}
